import { Dialog } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TermsConditionsDialog } from './terms-conditions';

@Component({
  selector: 'mai-copyright-and-legal-link',
  imports: [],
  templateUrl: './copyright-and-legal-link.html',
  host: {
    class: 'text-sm shrink-0',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyrightAndLegalLink {
  private dialog = inject(Dialog);

  openTermsAndConditions($event: MouseEvent | KeyboardEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.dialog.open(TermsConditionsDialog);
  }
}
